import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const CONTESTACION_AVISOS_EVENT = "contestacion-avisos-changed";

export function notifyContestacionAvisosChanged() {
  window.dispatchEvent(new Event(CONTESTACION_AVISOS_EVENT));
}

export async function fetchContestacionAvisos() {
  const token = localStorage.getItem("token");
  const { data } = await axios.get(
    `${API_URL}/api/presupuestos/contestacion-avisos`,
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return data || { items: [], count: 0 };
}

export async function postContestacionAviso(presupuestoId, accion) {
  const token = localStorage.getItem("token");
  const { data } = await axios.post(
    `${API_URL}/api/presupuestos/${presupuestoId}/contestacion-aviso`,
    { accion },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  notifyContestacionAvisosChanged();
  return data;
}
